import { render, staticRenderFns } from "./MenuLateral.vue?vue&type=template&id=4f1ac070"
import script from "./MenuLateral.vue?vue&type=script&lang=js"
export * from "./MenuLateral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports